// TOTO: Lưu dữ liệu khi user còn thao tác trên web thoát thì mất.
export const SessionStorageConfigKeys = {
  global: {},
  features: {
    noi_quy_lao_dong: {
      nghi_pheps: {
        filter: 'features.noi_quy_lao_dong.nghi_pheps.filters.filter',
        currentItem: 'features.noi_quy_lao_dong.nghi_pheps.currentItem',
      },
      tree_process: {
        status: 'features.noi_quy_lao_dong.tree_process.status',
      },
      hoc_tap_cong_tacs: {
        filter: 'features.noi_quy_lao_dong.hoc_tap_cong_tacs.filters.filter',
        currentItem: 'features.noi_quy_lao_dong.hoc_tap_cong_tacs.currentItem',
      },
      thong_ke_nghi_theo_tung_loai: {
        filter: 'features.noi_quy_lao_dong.thong_ke_nghi_theo_tung_loai.filters.filter',
        currentItem: 'features.noi_quy_lao_dong.thong_ke_nghi_theo_tung_loai.currentItem',
      },
      cai_dat: {
        don_vi: {
          list: 'features.noi_quy_lao_dong.noi_quy_lao_dong.cai_dat.don_vi.list'
        }
      },
      quan_ly: {
        quy_dinh: {
          canh_cao_sai_pham: {
            filter: 'feature.noi_quy_lao_dong.quan_ly.quy_dinh.canh_cao_sai_pham.filter',
          },
          tham_nien_cong_tac: {
            filters:
              'features.noi_quy_lao_dong.quan_ly.quy_dinh.setingThamNienCongTac.filters',
          },
          cheDoNghiPhep: {
            filters: 'features.cheDoNghiPhep.filters',
          },
          cheDoNghiPhepUserRule: {
            filters: 'features.cheDoNghiPhepUserRule.filters',
          },
        }
      },
      log: {
        filters: {
          filter: 'features.noi_quy_lao_dong.log.filters.filter'
        }
      }
    },
    khen_thuong_ky_luat: {
      shared: {
        general_category: "features.khen_thuong_ky_luat.shared.general_category",
        years_category: "features.khen_thuong_ky_luat.shared.years_category",
        namHoc_category: "features.khen_thuong_ky_luat.shared.namHoc_category",
        hocKy_category: "features.khen_thuong_ky_luat.shared.hocKy_category",
        khoa_category: "features.khen_thuong_ky_luat.shared.khoa_category",
        loai_khen_thuong_category: "features.khen_thuong_ky_luat.shared.loai_khen_thuong_category",
        loai_vi_pham_category: "features.khen_thuong_ky_luat.shared.loai_vi_pham_category",
        loai_file_bieu_mau_category: "features.khen_thuong_ky_luat.shared.loai_file_bieu_mau_category",
        hinh_thuc_ky_luat_category: "features.khen_thuong_ky_luat.shared.hinh_thuc_ky_luat_category",
      },
      cai_dat: {
        don_vi: {
          list: 'features.khen_thuong_ky_luat.cai_dat.don_vi.list'
        }
      },
      thong_ke_ggsheet: {
        ktkl_da_co_quyet_dinh: 'features.khen_thuong_ky_luat.thong_ke_ggsheet.ktkl_da_co_quyet_dinh'
      }
    },
    /**
    * Current selected template at import excel
    */
    import_excel: {
      currentSelectedTemplate: 'features.import_excel.currentSelectedTemplate',
      filterImportExcel: 'features.import_excel.filterImportExcel',
      selectedTemplateUploadExcel:
        'features.import_excel.selectedTemplateUploadExcel',
    },
    don_phieu_online_vien_htptdt: {
      dang_ky: {
        filter: 'features.don_phieu_online_vien_htptdt.dang_ky.filters.filter',
        currentItem: 'features.don_phieu_online_vien_htptdt.dang_ky.currentItem',
      },
      bieu_mau: {
        filter: 'features.don_phieu_online_vien_htptdt.bieu_mau.filters.filter',
        currentItem: 'features.don_phieu_online_vien_htptdt.bieu_mau.currentItem',
      },
      quan_ly: {
        filter: 'features.don_phieu_online_vien_htptdt.quan_ly.filters.filter',
        currentItem: 'features.don_phieu_online_vien_htptdt.quan_ly.currentItem',
      },
      dot_dang_ky: {
        filter: 'features.don_phieu_online_vien_htptdt.dot_dang_ky.filters.filter',
        currentItem: 'features.don_phieu_online_vien_htptdt.dot_dang_ky.currentItem',
      }
    },
    log: {
      filters: {
        filter: 'features.log.filters.filter'
      }
    },
    ticket_management: {
      shared: {
        nam_hoc: 'features.ticket_management.shared.nam_hoc',
      },
      cai_dat: {
        don_vi: {
          list: 'features.ticket_management.cai_dat.don_vi.list',
        },
      },
      sinh_vien: {
        filters: 'features.ticket_management.sinh_vien.filters'
      },
      quan_ly: {
        quanLyTicket: {
          filters: 'features.quanLyTicket.filters', // <-- Copy this line and paste to file `src/app/config/app-storage/session-storage.config.ts`
        },
      },
      confTicketType: {
        filters: 'features.ticket_management.confTicketType.filters',
      },
      confKnowledge: {
        filters: 'features.ticket_management.confKnowledge.filters',
      },
      supportDepartment: {
        filters: 'features.ticket_management.supportDepartment.filters',
      },
      confKeyChamSoc: {
        filters: 'features.confKeyChamSoc.filters',
      },
      feedback: {
        filters: 'features.feedback.filters',
      },
      confAutomatedSupportProcess: {
        filters: 'features.confAutomatedSupportProcess.filters',
      },
      supportDepartmentUser: {
        filters: 'features.ticket_management.supportDepartmentUser.filters',
      },
      thong_ke_ggsheet: {
        thong_tin_ticket: 'features.ticket_management.thong_ke_ggsheet.thong_tin_ticket',
      },
    },
    dao_tao_boi_duong_vpt: {
      skill: {
        filter: 'features.dao_tao_boi_duong_vpt.skill.filters.filter',
        currentItem: 'features.dao_tao_boi_duong_vpt.skill.currentItem',
      },
      skillUser: {
        filter: 'features.dao_tao_boi_duong_vpt.skillUser.filters.filter',
        currentItem: 'features.dao_tao_boi_duong_vpt.skillUser.currentItem',
      },
      user: {
        filter: 'features.dao_tao_boi_duong_vpt.user.filters.filter',
        currentItem: 'features.dao_tao_boi_duong_vpt.user.currentItem',
      },
    },
    tuyenSinhCapDongPhuc: {
      capPhatDongPhuc: {
        filters: 'features.tuyenSinhCapDongPhuc.capPhatDongPhuc.filters',
      },
      xuLyTrongNgay: {
        tongHopTrongNgay: {
          filters: 'features.tuyenSinhCapDongPhuc.xuLyTrongNgay.tongHopTrongNgay.filters',
        },
        doiTra: {
          filters: 'features.tuyenSinhCapDongPhuc.xuLyTrongNgay.doiTra.filters',
        }
      },
      thongKeBaoCao: {
        tong_hop: {
          filters: 'features.tuyenSinhCapDongPhuc.thongKeBaoCao.tong_hop.filters',
        },
        cap_phat: {
          filters: 'features.tuyenSinhCapDongPhuc.thongKeBaoCao.cap_phat.filters',
        }
      },
      sysSettingValue: {
        setting_vat_pham: 'features.tuyenSinhCapDongPhuc.sysSettingValue.setting_vat_pham',
        campus: 'features.tuyenSinhCapDongPhuc.sysSettingValue.campus',
      },
      thong_ke_ggsheet: {
        nhap_trong_ngay: 'features.tuyenSinhCapDongPhuc.thong_ke_ggsheet.nhap_trong_ngay'
      },
      dataBanDau: {
        filters: 'features.tuyenSinhCapDongPhuc.dataBanDau.filters',
      },
      log: {
        filters: {
          filter: 'features.tuyenSinhCapDongPhuc.log.filters.filter'
        }
      },
    },

    /**
     *(admin-sys-notify/notify-request) session storage luu cac key phuc vu module tuyen sinh cap dong phuc
    */
    /**
     * Sessoin storage luu cac key phuc vu module tuyen sinh cap dong phuc
     */
    notifyRequest: {
      filters: 'features.notifyRequest.filters',
      log: {
        filters: 'features.log.filters',
      },
      notifyTopic: {
        filters: 'features.notifyTopic.filters',
      },
      notifyUser: {
        filters: 'features.notifyUser.filters',
      }
    },
    dang_ky_khoa_hoc_lich_thi_tnnnkn: {
      dang_ky: {
        filter: 'features.dang_ky_khoa_hoc_lich_thi_tnnnkn.dang_ky.filters.filter',
        currentItem: 'features.dang_ky_khoa_hoc_lich_thi_tnnnkn.dang_ky.currentItem',
      },
      bieu_mau: {
        filter: 'features.dang_ky_khoa_hoc_lich_thi_tnnnkn.bieu_mau.filters.filter',
        currentItem: 'features.dang_ky_khoa_hoc_lich_thi_tnnnkn.bieu_mau.currentItem',
      },
      quan_ly: {
        filter: 'features.dang_ky_khoa_hoc_lich_thi_tnnnkn.quan_ly.filters.filter',
        currentItem: 'features.dang_ky_khoa_hoc_lich_thi_tnnnkn.quan_ly.currentItem',
      },
      dot_dang_ky: {
        filter: 'features.dang_ky_khoa_hoc_lich_thi_tnnnkn.dot_dang_ky.filters.filter',
        currentItem: 'features.dang_ky_khoa_hoc_lich_thi_tnnnkn.dot_dang_ky.currentItem',
      },
      mon_thi: {
        filter: 'features.dang_ky_khoa_hoc_lich_thi_tnnnkn.mon_thi.filters.filter',
        currentItem: 'features.dang_ky_khoa_hoc_lich_thi_tnnnkn.mon_thi.currentItem',
      }
    },

    /**
     * (thu-thap-thong-tin-truc-tuyen)
     */
    thuThapThongTinTrucTuyen: {
      m151024Categories: {
        filters: 'features.thuThapThongTinTrucTuyen.m151024Categories.filters',
      },
      m151024KhachHang: {
        filters: 'features.thuThapThongTinTrucTuyen.m151024KhachHang.filters',
      },
      m151024KhachHangLogEdited: {
        filters:
          'features.thuThapThongTinTrucTuyen.m151024KhachHangLogEdited.filters',
      },
      cai_dat: {
        don_vi: {
          list: 'features.thuThapThongTinTrucTuyen.cai_dat.don_vi.list',
        },
      },
    },

    /**
     */
    tuyenSinhDangkyHocBong: {
      m151024Categories: {
        filters: 'features.tuyenSinhDangkyHocBong.m151024Categories.filters',
      },
      m151024KhachHang: {
        filters: 'features.tuyenSinhDangkyHocBong.m151024KhachHang.filters',
      },
      m151024KhachHangLogEdited: {
        filters:
          'features.tuyenSinhDangkyHocBong.m151024KhachHangLogEdited.filters',
      },
      cai_dat: {
        don_vi: {
          list: 'features.tuyenSinhDangkyHocBong.cai_dat.don_vi.list',
        },
      },
    },
    // nhóm elearning module
    elearning: {
      lopHocPhan: {
        filters: 'features.elearning.lopHocPhan.filters',
      },
      thoiKhoaBieu: {
        teacher: {
          filters: 'features.elearning.thoiKhoaBieu.teacher.filters',
        },
        /** Màn "Thời khóa biểu" phía sinh viên — chuyển từ v3. */
        tkbSinhVien: {
          filters: 'features.elearning.thoiKhoaBieu.tkbSinhVien.filters',
        },
      },
      /** Màn "Lịch thi" phía sinh viên — chuyển từ v3. */
      sinhVienLichThi: {
        filters: 'features.elearning.sinhVienLichThi.filters',
      },
      /** Màn "Xem điểm" phía sinh viên — chuyển từ v3. */
      diemSinhVien: {
        filters: 'features.elearning.diemSinhVien.filters',
      },
      lop: {
        giangVien: {
          filters: 'features.elearning.lop.giangVien.filters',
          diem_danh_sinh_vien: {
            data: 'features.elearning.lop.giangVien.diem_danh_sinh_vien.data',
          },
        },
        sinhVien: {
          filters: 'features.elearning.lop.sinhVien.filters',
          diem_danh_sinh_vien: {
            data: 'features.elearning.lop.sinhVien.diem_danh_sinh_vien.data',
          },
        },
      },
      /**
       * Luu thong tin filter report nam hoc hoc ky
       * so_buoi_vang_hoc_sinh_vien: Thong ke so buoi vang hoc sinh vien theo nam hoc hoc ky
       * muc_canh_bao_vang_hoc_cao: Thong ke muc canh bao vang hoc cao
       * */
      thong_ke: {
        so_buoi_vang_hoc_sinh_vien: {
          nam_hoc_hoc_ky: {
            cap_truong:
              'features.elearning.so_buoi_vang_hoc_sinh_vien.nam_hoc_hoc_ky.cap_truong',
            cap_khoa:
              'features.elearning.so_buoi_vang_hoc_sinh_vien.nam_hoc_hoc_ky.cap_khoa',
          },
        },
        muc_canh_bao_vang_hoc_cao: {
          nam_hoc_hoc_ky: {
            cap_truong:
              'features.elearning.muc_canh_bao_vang_hoc_cao.nam_hoc_hoc_ky.cap_truong',
            cap_khoa:
              'features.elearning.muc_canh_bao_vang_hoc_cao.nam_hoc_hoc_ky.cap_khoa',
          },
        },
      },
    },
    sat: {
      mSatProfile: {
        filters: "features.mSatProfile.filters"
      },
      logs: {
        filters: 'features.sat.logs.filters',
      }
    },

    hoSoCaNhanV2: {
      mQuanLyHoatDongImport: {
        filters: 'features.mQuanLyHoatDongImport.filters', // <-- Sao chép dòng này và dán vào file `src/app/config/app-storage/session-storage.config.ts`
      },
    }
  }
}
